import Vue from 'vue';
import axios from "axios";
import locale from './locale';
import customerMainOidc from "../../customer_area/auth";
import dealerMainOidc from "../../dealer_area/auth";
import router from "../../dealer_area/router";

export async function errorResponseHandler(error) {

    // Refresh token on first 401 error from server for current request
    if (error.response && error.response.status === 401 && (app_scope === 'customer' || app_scope === 'dealer')) {
        let mainOidc = null;
        if (app_scope === 'customer') mainOidc = customerMainOidc;
        else if (app_scope === 'dealer') mainOidc = dealerMainOidc;
        else return Promise.reject(error);

        const originalRequest = error.config;
        if (!originalRequest._retry) {
            originalRequest._retry = true;
            await mainOidc.startSilentRenew();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + mainOidc.accessToken;
            originalRequest.headers['Authorization'] = 'Bearer ' + mainOidc.accessToken;
            return axios(originalRequest);
        }
    }

    // Disable error handling for requests that require it
    if( error.config.hasOwnProperty('errorHandle') && error.config.errorHandle === false ) {
        return Promise.reject(error);
    }

    // Otherwise, continue handling the error
    else if(error.response) {
        console.error(error.response);
        let title = locale.t('Error');
        let text = '';
        const { data, status } = error.response;

        switch (status) {
            case 400:
                if(data.sub_status === 'min_items') {
                  text = locale.t('Min order items {0} for request', [data.meta.min_items]);
                } else {
                  text = locale.t('resp_error.400');
                }
                break;
            case 401:
                text = locale.t('resp_error.401');
                window.location = `/${locale.locale}/${app_scope}/logout?redirect=${window.location}`;
                break;
            case 402:
                text = locale.t('resp_error.402');
                break;
            case 403:
                text = locale.t('resp_error.403');
                break;
            case 404:
                const message = data?.message || 'resp_error.404';
                text =  locale.t(message);
                break;
            case 409:
                if(data.sub_status === 'duplicated_request') {
                  text = locale.t('Uno o più servizi sono già stati richiesti per la stessa/e matricola/e');
                } else {
                  text = locale.t(data.message);
                }
                break;
            case 422:
                let errors = [];
                if(Array.isArray(error.response.data.errors))
                    if (Array.isArray(error.response.data.errors[0])) errors = error.response.data.errors.map(e => e.join('<br>'));
                    else errors = error.response.data.errors.map(e => e.detail);
                else if(error.response.data.errors instanceof Object)
                    errors = Object.keys(error.response.data.errors).map(e => error.response.data.errors[e].join('<br>'));
                text = errors.length > 0
                  ? errors.join('<br>')
                  : locale.t('The data entered contain some errors');
                break;
            case 423:
                if(data.sub_status === 'prepayment') {
                  text = locale.t('A problem occurred. Please contact your representative.'); // TODO: Cambiare per x3_prepayment?
                } else {
                  text = locale.t('A problem occurred. Please contact your representative.');
                }
                break;
            case 451:
                text = locale.t(data.message);
                break;
            case 491:
                await router.push({name: 'Msg', params: {msg: locale.t(data.message)}});
                break;
            case 500:
                text = locale.t('resp_error.500');
                break;
            default:
                break;
        }

        if (text) {
          Vue.notify({
            title: title,
            text: text,
            type: 'error',
          });
        }

        return Promise.reject(error);
    }
}
